import { render } from "./OurNews.vue?vue&type=template&id=5f34f75c&scoped=true"
import script from "./OurNews.vue?vue&type=script&lang=js"
export * from "./OurNews.vue?vue&type=script&lang=js"

import "./OurNews.vue?vue&type=style&index=0&id=5f34f75c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f34f75c"]])

export default __exports__